import script from "./SectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionCard.vue?vue&type=script&setup=true&lang=js"

import "./SectionCard.vue?vue&type=style&index=0&id=787c86b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787c86b1"]])

export default __exports__